// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lenisna-product h6 {
    /* padding-top: 0!important; */
    color: #7B1237 !important;
    font-family: "ParagraphFonts", serif !important;
    font-weight: bold;
    margin-bottom: 8px;

}

@media(min-width: 992px) {
    .lenisna-product .container{
        padding-left: 172px!important;
        padding-right: 172px!important;
    }
    .subtitle-p {
        margin-bottom: 48px
    }

    .lenisna-product h6 {
        font-size: 0.875rem;
    }

    .lenisna-product li , .lenisna-product p {
        font-size: 13px !important;
    }

    .key-benifits-h6 {
        padding-top: 132px;


    }
}


@media(min-width:768px) and (max-width:991px) {
    .lenisna-product .cotainer{
        padding-left: 64px !important;
        padding-right: 64px !important;
    }
    /* html[dir='rtl'] .juvelook-product */

    .lenisna-product h5,
    .lenisna-product h6 {
        font-size: 11px !important;
        font-weight: 600 !important;
    }

    .lenisna-product p,
    .lenisna-product li {
        font-size: 9px !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/LenisnaProductComponent.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,+CAA+C;IAC/C,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;IACA;QACI;IACJ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;;;IAGtB;AACJ;;;AAGA;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;IACA,sCAAsC;;IAEtC;;QAEI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;;QAEI,yBAAyB;IAC7B;;AAEJ","sourcesContent":[".lenisna-product h6 {\n    /* padding-top: 0!important; */\n    color: #7B1237 !important;\n    font-family: \"ParagraphFonts\", serif !important;\n    font-weight: bold;\n    margin-bottom: 8px;\n\n}\n\n@media(min-width: 992px) {\n    .lenisna-product .container{\n        padding-left: 172px!important;\n        padding-right: 172px!important;\n    }\n    .subtitle-p {\n        margin-bottom: 48px\n    }\n\n    .lenisna-product h6 {\n        font-size: 0.875rem;\n    }\n\n    .lenisna-product li , .lenisna-product p {\n        font-size: 13px !important;\n    }\n\n    .key-benifits-h6 {\n        padding-top: 132px;\n\n\n    }\n}\n\n\n@media(min-width:768px) and (max-width:991px) {\n    .lenisna-product .cotainer{\n        padding-left: 64px !important;\n        padding-right: 64px !important;\n    }\n    /* html[dir='rtl'] .juvelook-product */\n\n    .lenisna-product h5,\n    .lenisna-product h6 {\n        font-size: 11px !important;\n        font-weight: 600 !important;\n    }\n\n    .lenisna-product p,\n    .lenisna-product li {\n        font-size: 9px !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
